import { NotificationList } from '@/components/notifications/NotificationList';

export function NotificationDropdown({ onClose }: { onClose: () => void }) {
  return (
    <div className="notification-dropdown" role="menu">
      <div className="notification-dropdown__header">
        <h3>Notifications</h3>
        <button onClick={onClose} aria-label="Close">
          <i className="ti ti-x" />
        </button>
      </div>
      <NotificationList />
    </div>
  );
}
